import React from 'react';
import Lottie from 'react-lottie-player';
import * as MarkerAnimation from '../MarkerAnimations/HighGuaranteedShipmentsMarkerAnimation.json';

const GuarenteedMarker = (props) => {
  return (
    <div>
      <Lottie
        loop
        play
        animationData={MarkerAnimation.default}
        style={{ width: props.dimension, height: props.dimension }}
      />
    </div>
  );
};
export default GuarenteedMarker;
